<div
  class="uni-status__bullet"
  [ngClass]="[
    'uni-status__bullet--' + status,
    'uni-status__bullet--margin-' + margin,
    'uni-status__bullet--' + size
  ]"
></div>
<ng-content></ng-content>
